export const comSaldoOptions = [
  { label: 'SIM', value: 'S' },
  { label: 'NAO', value: 'N' },
];
